import { HandOverWatch } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const HAND_OVER_WATCH_DATA_TAG = 'HandOverWatch';
export default class HandOverWatchParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.HAND_OVER_WATCH, FIXED_PROTOCOL_CONTENT_TYPE_IDS.HAND_OVER_WATCH, HAND_OVER_WATCH_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            handOverWatchTo: 'handOverWatchTo',
            authorRole: 'authorRole',
            oow: 'oow',
            freeText: 'freeText',
            logReading: 'logReading',
        };
    }
    createData(props) {
        return new HandOverWatch(props.handOverWatchTo, props.authorRole, props.oow, props.freeText, props.logReading);
    }
}
//# sourceMappingURL=HandOverWatchParser.js.map